import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';

import { HomeComponent } from './home';
import { AuthGuard } from './_helpers';
import { CoursePlayerComponent } from './courses/course-player/course-player.component'
import { CourseLandingPageComponent } from './courses/course-landing-page/course-landing-page.component';

const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const usersModule = () => import('./users/users.module').then(x => x.UsersModule);

import { LoginComponent } from './account/login.component';

import { RegisterComponent } from './account/register.component';
import { MyAccountComponent } from './account/my-account/my-account.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'login', component: LoginComponent },
    //{ path: 'register', component: RegisterComponent },
    { path: 'account', component: MyAccountComponent, canActivate: [AuthGuard]  },
    { path: 'course-landing-page', component: CourseLandingPageComponent, canActivate: [AuthGuard] },
    { path: 'french-basic-course', component: CoursePlayerComponent, data : { 
      course : 'french-basic',
      audioUrl: 'https://fsi-application.s3.amazonaws.com/french-basic/audio/fsi-french-course-volume-01-unit-01.mp3'
    } },
    { path: 'german-basic-course', component: CoursePlayerComponent, data : { 
      course : 'german-basic',
      audioUrl: 'https://fsi-application.s3.amazonaws.com/german-basic/audio/fsi-german-course-volume-01-unit-01.mp3'
    } },
    { path: 'spanish-basic-course', component: CoursePlayerComponent, data : { 
      course : 'spanish-basic',
      audioUrl: 'https://fsi-application.s3.amazonaws.com/spanish-basic/audio/fsi-spanish-course-volume-01-unit-01.mp3'
    } },
    { 
      path: 'latin-america-spanish-course', component: CoursePlayerComponent, canActivate: [AuthGuard], data : 
      { 
        course : 'latin-spanish',
        courseId: '5fa6d2a7700f612b3858aecd'
      } 
    },    
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }